import { FunctionComponent, useState } from 'react';
import Slider from 'react-slick';
import AdsProductsWrapper from './adsProduct.style';
import ArrowIcon from '../../public/icon/Arrow';
import { LAWTALK_ADS } from '@shared/values';

const AdsProducts: FunctionComponent = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide > 0) {
      return (
        <div
          className={className}
          style={{ ...style, transform: 'rotate(90deg)', left: '44px', top: 'calc(50% - 11px)', zIndex: '2' }}
          onClick={onClick}
        >
          <ArrowIcon width="25px" height="25px" />
        </div>
      );
    } else {
      return <></>;
    }
  }
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide < LAWTALK_ADS.length - 1) {
      return (
        <div
          className={className}
          style={{ ...style, transform: 'rotate(-90deg)', right: '41px', top: 'calc(50% - 10px)' }}
          onClick={onClick}
        >
          <ArrowIcon width="25px" height="25px" />
        </div>
      );
    } else {
      return <></>;
    }
  }

  const settings = {
    dots: true,
    infinite: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    variableWidth: true,
    beforeChange: (_: number, next: number) => {
      setCurrentSlide(next);
    },
  };
  return (
    <AdsProductsWrapper>
      <div className="adsproducts--header">
        <p className="adsproducts--header-title">
          더 많은 의뢰인을 만나는
          <br />
          효율적인 방법
          <br />
          <span>로톡AD</span>
        </p>
        <p className="adsproducts--header-desc">
          로톡AD는 변호사님이 원하는 분야의 의뢰인을 타겟팅해 효율적으로 운영가능한 로톡 광고상품입니다.
        </p>
      </div>
      <div className="adsproducts--body mobile">
        <div className="adsproducts--contents">
          <div className="adsproducts--products">
            <Slider {...settings}>
              {LAWTALK_ADS.map((_, index) => (
                <div className="adsproducts--product" key={index}>
                  <div className={`adsproducts--product-image index-${index}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="adsproducts--product-description-wrap">
          <div className="adsproducts--product-header">
            <p className="adsproducts--product-title">{LAWTALK_ADS[currentSlide].title}</p>
          </div>
          <p className="adsproducts--product-desc">{LAWTALK_ADS[currentSlide].logDescription}</p>
        </div>
      </div>
      <div className="adsproducts--body desktop">
        {/* 
            // @ts-ignore */}
        <div className="adsproducts--products">
          {LAWTALK_ADS.map((product, index) => (
            <div className="adsproducts--product" key={index}>
              <div className="adsproducts--product-image-wrap">
                <div className="adsproducts--product-image" />
              </div>
              <div className="adsproducts--product-header">
                <p className="adsproducts--product-title">{product.title}</p>
              </div>
              <p className="adsproducts--product-desc">{product.logDescription}</p>
            </div>
          ))}
        </div>
      </div>
    </AdsProductsWrapper>
  );
};

export default AdsProducts;
